import { ReactNode } from 'react'
import { Box, Tooltip, styled } from '@mui/material'
import { IconButton } from '@carto/meridian-ds/components'
import { CheckCircleOutline, ErrorOutline, CancelOutlined } from '@mui/icons-material'
import { JobStatusType } from 'features/jobs/types'
import { ICON_SIZE_MEDIUM } from '@carto/meridian-ds/theme'

const CancelIconStyled = styled(CancelOutlined)(({ theme }) => ({
  color: theme.palette.text.secondary
}))

const IconBox = styled(Box)(() => ({
  width: ICON_SIZE_MEDIUM,
  height: ICON_SIZE_MEDIUM,
  svg: {
    width: ICON_SIZE_MEDIUM,
    height: ICON_SIZE_MEDIUM
  }
}))

function JobItemIcon({
  status,
  tooltip,
  onClick
}: {
  status: JobStatusType
  tooltip?: string | ReactNode
  onClick?: () => void
}) {
  const jobIsSuccess = status === JobStatusType.Success
  const jobIsError = status === JobStatusType.Failure

  const icon = jobIsSuccess ? (
    <CheckCircleOutline color="success" />
  ) : jobIsError ? (
    <ErrorOutline color="error" />
  ) : (
    <CancelIconStyled aria-label="cancel-job-icon" />
  )

  const content = onClick ? (
    <IconButton onClick={onClick} size="small" aria-label="cancel" icon={icon} />
  ) : (
    <IconBox>{icon}</IconBox>
  )
  return (
    <Box display="flex" alignItems="center">
      {tooltip ? (
        <Tooltip title={tooltip} placement="top" arrow>
          {content}
        </Tooltip>
      ) : (
        content
      )}
    </Box>
  )
}

export default JobItemIcon
